import React from "react";

const ThreeDotsLoader = () => {
    return (
        <div className="flex justify-center items-center gap-2 py-2">
            <span
                className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
            ></span>

            <span
                className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                style={{ animationDelay: "0.15s" }}
            ></span>

            <span
                className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                style={{ animationDelay: "0.3s" }}
            ></span>
        </div>
    );
};

export default ThreeDotsLoader;